/* One layout at every width: title, body, then the button on its own line */
.root {
  user-select: none;
}

/* WCAG 2.5.8: a real button with a 24px minimum target, 44px where touch is the pointer */
.remove {
  margin-top: var(--tuna-spacing-2, 8px);
  min-height: 24px;
}

@media (pointer: coarse) {
  .remove {
    min-height: 44px;
  }
}
